import { createApiQueryClient, createApiQueryPersister } from '@sequencehq/api'

export const apiQueryClient = createApiQueryClient()
export const apiQueryPersister = createApiQueryPersister()
